import { Skeleton } from '@massilia/ui'

export function InformationsLoadingSkeleton() {
  return (
    <div className="flex w-full flex-col gap-8 px-4 py-8 md:px-28 lg:flex-row lg:gap-12">
      <div className="flex flex-1 flex-col gap-6">
        <Skeleton className="h-8 w-64 rounded-xl" />
        <Skeleton className="h-6 w-96 rounded-xl" />
        <Skeleton className="h-48 w-full rounded-xl" />
        <Skeleton className="h-48 w-full rounded-xl" />
        <Skeleton className="h-48 w-full rounded-xl" />
      </div>
      <div className="hidden w-96 md:block">
        <Skeleton className="h-96 w-full rounded-xl" />
      </div>
    </div>
  )
}
